const initialState = {
    expenseList: [],
    isAddingExpense: false,
    isFetchingExpenseByOrderCategory: false,
    expenseByOrderCategoryData: [],
};

const ExpenseReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_ADD_EXPENSE":
            return { ...state, isAddingExpense: true };
        case "SUCCESS_ADD_EXPENSE":
            return { ...state, expenseList: action.payload, isAddingExpense: false, };
        case "ERROR_ADD_EXPENSE":
            return { ...state, isAddingExpense: false };


        case "REQUEST_GET_EXPENSE_BY_ORDER_CATEGORY":
            return { ...state, isFetchingExpenseByOrderCategory: true };
        case "SUCCESS_GET_EXPENSE_BY_ORDER_CATEGORY":
            return { ...state, expenseByOrderCategoryData: action.payload, isFetchingExpenseByOrderCategory: false };
        case "ERROR_GET_EXPENSE_BY_ORDER_CATEGORY":
            return { ...state, isFetchingExpenseByOrderCategory: false };


        default:
            return state;
    }
};
export default ExpenseReducer;